<template>
  <div class="m-section">
	  <div class="m-section__content">
      <div class="scroll-datatable">
      <table class="table table-striped m-table" >
        <thead class="thead-inverse table-header">
          <tr>
            <th v-if="config.check">
              <label class="m-checkbox m-checkbox--solid" >
                <input type="checkbox" @change.prevent="checkAll">
                <span></span>
              </label>
            </th>
            <th v-for="column in config.columns" :key="column.field" @click.prevent="sortDatatable(column.field)" class="cursor-pointer">
              {{ column.title | capitalize}}
              <i v-if="sort_name === column.field || sort_name === `-${column.field}`" :class="sort_name=== column.field ? 'fa fa-sort-asc px-1': 'fa fa-sort-desc px-1'"></i>
            </th>
            <th v-if="config.state">{{ 'state' | capitalize }}</th>
            <th v-if="config.actions">{{ 'actions' | capitalize }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in data" :key="row.id">
            <td v-if="config.check">
              <label class="m-checkbox" >
                <input type="checkbox" name="checkbox-datatable" @change.prevent="changeCheck(row.id, $event)" value="row.id">
                <span></span>
              </label>
            </td>
            <td v-for="column in config.columns" :key="column.field" v-html="((column.template) ? column.template(row) : row[column.field])"></td>
            <td v-if="config.state"><slot name="state" :row="row" class="topSlotMiddle"></slot></td>
            <td v-if="config.actions"><slot name="actions" :row="row"></slot></td>
          </tr>
          <tr v-if="data.length == 0">
            <td :colspan="config.columns.length + (config.actions ? 1 : 0) + (config.check ? 1 : 0) + (config.state ? 1 : 0)">{{ 'no_data_available' | capitalize }}</td>
          </tr>

        </tbody>
      </table>
      </div>
      <div class="m_datatable m-datatable m-datatable--default m-datatable--loaded">
        <div class="m-datatable__pager m-datatable--paging-loaded clearfix">
          <ul class="m-datatable__pager-nav">
            <li>
              <a :title="'first' | titleize" class="m-datatable__pager-link m-datatable__pager-link--first" @click="changeFirstPage()">
                <i class="la la-angle-double-left"></i>
              </a>
            </li>
            <li>
              <a :title="'previous' | titleize" class="m-datatable__pager-link m-datatable__pager-link--prev" @click="changePreviousPage()">
                <i class="la la-angle-left"></i>
              </a>
            </li>
            <li style="display: none;">
              <a :title="'more_pages' | titleize" class="m-datatable__pager-link m-datatable__pager-link--more-prev">
                <i class="la la-ellipsis-h"></i>
              </a>
            </li>
            <li style="display: none;">
              <input type="text" class="m-pager-input form-control" :title="'page_number' | titleize">
            </li>
            <li v-for="page in activePages" :key="page">
              <a class="m-datatable__pager-link m-datatable__pager-link-number" :class="{ 'm-datatable__pager-link--active' : meta.page === page }" :title="page" @click="changePage(page)">{{ page }}</a>
            </li>
            <li>
              <a :title="'next' | titleize" class="m-datatable__pager-link m-datatable__pager-link--next" @click="changeNextPage()">
                <i class="la la-angle-right"></i>
              </a>
            </li>
            <li>
              <a :title="'last' | titleize" class="m-datatable__pager-link m-datatable__pager-link--last" @click="changeLastPage()">
                <i class="la la-angle-double-right"></i>
              </a>
            </li>
          </ul>
          <div class="m-datatable__pager-info">
            <div class="btn-group bootstrap-select m-datatable__pager-size" style="width: 70px;">
              <button type="button" class="btn dropdown-toggle btn-default" data-toggle="dropdown" role="button" :title="'page_size' | capitalize">
                <span class="filter-option pull-left">{{ meta.perpage }}</span>&nbsp;
                <span class="bs-caret">
                  <span class="caret"></span>
                </span>
              </button>
              <div class="dropdown-menu open" role="combobox">
                <ul class="dropdown-menu inner" role="listbox" aria-expanded="false">
                  <li v-for="(size, index) in pagination.sizes" :key="index" :data-original-index="index" :class="(meta.perpage === size) ? 'selected' : ''">
                    <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" :aria-selected="(meta.perpage === size) ? true : false" @click.prevent="changeSize(size)">
                      <span class="text">{{ size }}</span>
                      <span class="glyphicon glyphicon-ok check-mark"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <span class="m-datatable__pager-detail">{{'displaying' | titleize}} {{ startPage }} - {{ endPage }} {{'of' | translate}} {{ meta.total }} {{'records' | translate}}</span>
          </div>
        </div>
      </div>
	  </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import service from '@/services/superaccess'

export default {
  props: {
    config: { required: true, type: Object },
    show_spinner: { required: false, type: Boolean, default: true }
  },
  data () {
    return {
      sort_name: '',
      check_list: [],
      data: {},
      meta: {
        page: 0,
        pages: 0,
        perpage: 50,
        sort: '',
        field: '',
        total: 0
      },
      pagination: {
        sizes: [10, 20, 30, 50, 100]
      }
    }
  },
  computed: {
    startPage () {
      const start = (this.meta.page * this.meta.perpage) - this.meta.perpage + 1
      return (start < 0 || this.meta.total === 0) ? 0 : start
    },
    endPage () {
      const end = (this.meta.page * this.meta.perpage)
      return (end > this.meta.total) ? this.meta.total : end
    },
    activePages () {
      const indicator = this.meta.page
      let counter = 1
      let pages = []

      if (indicator > 0) {
        pages.push(indicator)
      }

      while (counter <= 3) {
        const prev = indicator - counter
        const next = indicator + counter

        if (prev > 0) {
          pages.push(prev)
        }

        if (next <= this.meta.pages) {
          pages.push(next)
        }
        counter = counter + 1
      }
      return pages.sort((a, b) => {
        return a - b
      })
    },
    update () {
      return this.config.update
    },
    clean () {
      return this.config.clean
    },
    ...mapGetters({shard: 'getUserShard'})
  },
  methods: {
    changePage (page) {
      if (page > 0 && this.meta.page !== page) {
        this.meta.page = page
        this.reload()
      }
    },
    changeFirstPage () {
      this.meta.page = (this.meta.pages > 0) ? 1 : 0
      this.reload()
    },
    changeLastPage () {
      this.meta.page = this.meta.pages
      this.reload()
    },
    changePreviousPage () {
      const previous = this.meta.page - 1
      if (previous > 0) {
        this.meta.page = previous
        this.reload()
      }
    },
    changeNextPage () {
      const next = this.meta.page + 1
      if (next <= this.meta.pages) {
        this.meta.page = next
        this.reload()
      }
    },
    changeSize (size) {
      this.meta.perpage = size
      this.meta.page = 1
      this.meta.pages = Math.ceil(this.meta.total / size)
      this.reload()
    },
    reload () {
      const self = this
      const data = {
        meta: this.meta,
        query: this.config.query
      }
      if (this.show_spinner) this.$spinner.show()
      axios({ url: this.config.url, method: this.config.method, data: data })
        .then((res) => {
          this.meta = res.data.meta
          this.data = res.data.data
          self.$emit('data', this.data)
          self.$emit('final_query', true)
          if (this.sort_name !== '') {
            this.data.sort(this.dynamicSort(this.sort_name))
          }
          if (this.show_spinner) this.$spinner.remove()
        })
        .catch((err) => {
          console.log(err)
          self.$emit('final_query', false)
          if (this.show_spinner) this.$spinner.remove()
        })
    },
    checkAll (event) {
      if (event.target.checked) {
        this.check_list = []
        this.data.forEach(element => {
          this.check_list.push(element.id)
        })
      } else {
        this.check_list = []
      }
      this.$emit('checks', this.check_list)
      let checkboxes = document.getElementsByName('checkbox-datatable')
      checkboxes.forEach(element => {
        element.checked = event.target.checked
      })
    },
    refreshCheck () {
      let checkboxes = document.getElementsByName('checkbox-datatable')
      checkboxes.forEach(element => {
        const temp = this.check_list.find(elem => elem === element.value)
        element.checked = temp !== undefined
      })
    },
    changeCheck (id, event) {
      if (event.target.checked) {
        this.check_list.push(id)
      } else {
        const index = this.check_list.findIndex((elem) => elem === id)
        this.check_list.splice(index, 1)
      }
      this.$emit('checks', this.check_list)
    },
    sortDatatable (name) {
      if (name === this.sort_name) {
        this.sort_name = `-${name}`
      } else {
        this.sort_name = name
      }
      this.data.sort(this.dynamicSort(this.sort_name))
    },
    dynamicSort (property) {
      let sortOrder = 1
      if (property[0] === '-') {
        sortOrder = -1
        property = property.substr(1)
      }
      return function (a, b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
        return result * sortOrder
      }
    }
  },
  mounted () {
    const self = this
    this.$nextTick().then(function () {
      const data = {
        meta: self.meta,
        query: self.config.query
      }
      self.$spinner.show()
      service.post(self.config.url, self.$store, data)
        .then((res) => {
          self.meta = res.data.meta
          self.data = res.data.data
          self.$spinner.remove()
        })
        .catch((err) => {
          console.log(err)
          self.$spinner.remove()
        })
    })
  },
  watch: {
    update (newVal, oldVal) {
      if (newVal !== false) {
        this.config.update = false
        this.check_list = []
        this.$emit('checks', this.check_list)
        this.refreshCheck()
        this.reload()
      }
    },
    clean (newVal, oldVal) {
      if (newVal !== false) {
        this.config.clean = false
        this.data = {}
        this.meta = {
          page: 0,
          pages: 0,
          perpage: 10,
          sort: '',
          field: '',
          total: 0
        }
      }
    }
  }
}
</script>

<style scoped>

.thead-inverse th {
  background: #1F2742!important;
  color: #FFF !important
}
.table th, .table td {
  text-align: center;
}

thead {
  color: #FFF !important
}

.scroll-datatable {
  max-height: 650px;
  overflow: auto;
  display: block;
  white-space: nowrap;
}
.table td {
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.m-checkbox.m-checkbox--solid > span:after {
  border: solid #1f2742;
}
.m-checkbox.m-checkbox--solid > input:checked ~ span {
  background: #ffffff;
}
.m-checkbox.m-checkbox--solid > span{
  background: #ffffff;
}

.m-checkbox > span {
  top: -3px;
}

</style>



// WEBPACK FOOTER //
// Datatable.vue